import React from "react";
import { Box } from "@mui/material";
import StaffManagementList from "./StaffManagementList";

const StaffList = () => {
  return (
    <Box className="container">
      <StaffManagementList />
    </Box>
  );
};

export default StaffList;
